import { render, staticRenderFns } from "./novle_list.vue?vue&type=template&id=6dff8c88&scoped=true"
import script from "./novle_list.vue?vue&type=script&lang=js"
export * from "./novle_list.vue?vue&type=script&lang=js"
import style0 from "./novle_list.vue?vue&type=style&index=0&id=6dff8c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff8c88",
  null
  
)

export default component.exports